var PipesModule = /** @class */ (function () {
    function PipesModule() {
    }
    return PipesModule;
}());
export { PipesModule };
